"use strict";
exports.__esModule = true;
exports.invariant = void 0;
function invariant(value, message, error) {
    if (error === void 0) { error = new Error(); }
    if (value) {
        error.message = message;
        throw error;
    }
}
exports.invariant = invariant;
